"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildMenuLookup = void 0;
const buildMenuLookup = (items) => {
    const stationsById = new Map();
    const parentIdsByStationId = new Map();
    const parentNamesByStationId = new Map();
    const trainsById = new Map();
    for (const item of items) {
        if (!stationsById.has(item.Id)) {
            stationsById.set(item.Id, item);
        }
    }
    const getParentIds = (stationId) => {
        const cachedValue = parentIdsByStationId.get(stationId);
        if (cachedValue) {
            return cachedValue;
        }
        const station = stationsById.get(stationId);
        if (!station) {
            return [];
        }
        const parentIds = station.ParentId ? [...getParentIds(station.ParentId), station.Id] : [station.Id];
        parentIdsByStationId.set(stationId, parentIds);
        return parentIds;
    };
    const getParentNames = (stationId) => {
        const cachedValue = parentNamesByStationId.get(stationId);
        if (cachedValue) {
            return cachedValue;
        }
        const parentNames = getParentIds(stationId)
            .map(parentId => { var _a; return (_a = stationsById.get(parentId)) === null || _a === void 0 ? void 0 : _a.Name; })
            .filter((name) => !!name);
        parentNamesByStationId.set(stationId, parentNames);
        return parentNames;
    };
    for (const item of items) {
        getParentIds(item.Id);
        getParentNames(item.Id);
        for (const train of item.Trains) {
            if (!train.TrainId) {
                continue;
            }
            trainsById.set(train.TrainId, Object.assign(Object.assign({}, train), { ParentId: item.Id, ParentsNames: getParentNames(item.Id) }));
        }
    }
    return {
        stationsById,
        parentIdsByStationId,
        parentNamesByStationId,
        trainsById,
    };
};
exports.buildMenuLookup = buildMenuLookup;
//# sourceMappingURL=menu-lookup.js.map